"use client";
import type { SearchParams } from "algoliasearch";
import logger from "@/lib/logger";
import getPublicClient from "@/lib/algolia/getPublicClient";

type MultiSearchRequest = {
  indexName: string;
  params?: SearchParams;
};

type MultiSearchResponse<T> = {
  results: Array<{
    hits: T[];
    facets?: Record<string, Record<string, number>>;
    page?: number;
    nbPages?: number;
    nbHits?: number;
    query?: string;
  }>;
};

export const clientSearch = async <T>(
  requests: MultiSearchRequest[],
): Promise<MultiSearchResponse<T>> => {
  try {
    const client = getPublicClient();
    const response = await client.search<T>(requests);
    return response;
  } catch (e) {
    const message = "Error executing client-side search";
    logger.error(message, e);
    return { results: [] };
  }
};

export default clientSearch;
